"use client";

import ScrollAnimation from "./ScrollAnimation";
import { motion } from "framer-motion";
import AggressiveSparks from "./AggressiveSparks";

export default function AboutSection() {
  return (
    <section className="section-block text-center py-16" id="about">
      <ScrollAnimation animation="fade-in">
        <h2 className="mb-12 glitch-hover" data-text="Das sind wir">Das sind wir</h2>
        
        <div className="max-w-4xl mx-auto px-4 relative">
          <AggressiveSparks />
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="band-description bg-gradient-to-br from-primary/40 to-black/60 backdrop-blur-md border border-white/10 p-8 md:p-12 rounded-2xl shadow-2xl relative overflow-hidden group"
          >
            {/* Subtle decorative element */}
            <div className="absolute -top-24 -right-24 w-48 h-48 bg-accent/5 rounded-full blur-3xl group-hover:bg-accent/10 transition-colors duration-700" />
            
            <div className="relative z-10 mb-8 rounded-xl">
              {/* Aggressive fire/sparks glow behind image */}
              <div className="absolute -inset-4 bg-orange-700 rounded-xl blur-3xl opacity-30 pointer-events-none" />
              
              <img 
                src="/img/Gruppenbild_neu.jpg" 
                alt="Becoming Wind Band" 
                className="relative w-full h-auto object-cover rounded-xl hover:scale-105 transition-transform duration-700 z-10 shadow-2xl"
              />
            </div>
            
            <div className="relative z-10 space-y-6 text-lg md:text-xl leading-relaxed font-serif text-gray-200">
              <p>
                Wir sind <span className="text-accent font-bold font-oswald uppercase tracking-wider">Becoming Wind</span>, eine melodic Folk-Metal Band aus NRW. Wir verbinden kraftvolle Gitarrenriffs mit facettenreichen orchestralen Arrangements. Inhaltlich entführen unsere Songs in eine von Mythen, Sagen und Fantasy geprägte Welt voller spannender Reisen, Abenteuern sowie Gefahren, die erfüllt von persönlicher Entwicklung und dem Umgang mit eigenen Herausforderungen sind.
              </p>
              
              <p>
                Daraus entsteht ein vielseitiger und eigenständiger Sound, der seit Juni 2025 auf unserem Debütalbum <span className="text-accent italic font-medium">&quot;Chapter I: Ex Libris&quot;</span> zu hören ist. Mit dieser Veröffentlichung haben wir unseren ersten großen Meilenstein unserer musikalischen Reise erreicht. Weitere Kapitel dieser Reise werden folgen, die für uns jeweils eine neue musikalische Ära einleiten.
              </p>
            </div>

            {/* Bottom accent line */}
            <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-accent/30 to-transparent" />
          </motion.div>
        </div>
      </ScrollAnimation>
    </section>
  );
}
